import { render, staticRenderFns } from "./RegisterInfo.vue?vue&type=template&id=2ffe652c"
import script from "./RegisterInfo.vue?vue&type=script&lang=js"
export * from "./RegisterInfo.vue?vue&type=script&lang=js"
import style0 from "./RegisterInfo.vue?vue&type=style&index=0&id=2ffe652c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports